module.exports = __webpack_public_path__ + "img/footer-logo.0d60e19f.png";